<style lang="scss" scoped>
.color-container {
    .content {
        padding: 15px;

        .title-button {
            margin-bottom: 15px;
        }
    }
}
.content-desc {
    padding: 15px;
    // font-weight: bold;
}
.color-success {
    color: #19be6b;
}
.color-default {
    color: #333;
}
</style>
<template>
    <div style="position: relative">
        <compWrapper
            class="color-container"
            :theme="nowData.theme"
            :title="nowData.title"
        >
            <!-- 普通优先级不用展示 -->
            <div v-if="nowData.type !== 2" class="content">
                <div class="title-button">
                    <Button type="primary" @click="handleOperate('add')"
                        >{{$t('global.common.add',{defaultValue:'添加'})}}</Button
                    >
                </div>
                <Table :columns="columns" :data="tableData"></Table>
            </div>
            <div class="content-desc" v-else>
                {{nowData.desc}}
            </div>
        </compWrapper>
        <compModal v-model="operate.show" v-bind="operate">
            <component
                v-if="operate.component"
                :is="operate.component"
                v-bind="operate.props"
            />
        </compModal>
        <Spin v-if="loading" size="large" fix></Spin>
    </div>
</template>

<script>
import mixin from "./mixin";
import compUpdate from "./update";
import {
    HttpGetRulesList,
    HttpActiveRule,
    HttpDisableRule,
} from "@/service/rules/rules";
export default {
    props: ["type", "search", "updateNow"],
    mixins: [mixin],
    components: { compUpdate },
    watch: {
        updateNow: {
            immediate: true,
            handler(val) {
                if (!val) return;
                this.update();
            },
        },
        typeList: {
            handler (val) {
                this.handleTypeList();
            },
        }
    },
    data() {
        return {
            loading: true,
            nowData: {},
            operate: {
                show: false,
            },
            tableData: [
                {
                    code: "100001",
                    name: this.$t('erp.rules.linecope',{defaultValue:'XX项目cope仓库优先发货'}),
                    warehouseId: 3,
                    status: 1,
                    updatedAt: "2019-02-11 07:19:32",
                },
            ],
        };
    },
    created () {
        this.handleTypeList();
    },
    methods: {
        handleTypeList () {
            // 设定优先级
            this.nowData = this.typeList.filter((item) => {
            return item.type === this.type;
            })[0];
            this.update();
        },
        /**
         * 更新数据
         */
        async update() {
            this.loading = true;
            let tempSearchData = this.search;
            let { channelId, productId, ...searchData } = { ...tempSearchData };
            await HttpGetRulesList({
                page: 1,
                rows: 1000,
                sidx: "id",
                sord: "desc",
                search: {
                    ...searchData,
                    EQ_ruleType: this.nowData.ruleType,
                    EQ_sortorder: this.nowData.sortorder,
                },
                productId,
                channelId,
                sortorder: this.nowData.sortorder,
            }).then(
                (res) => {
                    this.tableData = res.data.content;
                },
                (err) => {
                    this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                }
            );
            this.loading = false;
        },
        handleOperate(type, param) {
            switch (type) {
                case "add":
                    {
                        let url = this.$router.resolve({
                            name: "warehouseDeliverUpdate",
                            params: {
                                type: "add",
                                level: this.nowData.type,
                            },
                        })
                        window.open(url.href, '_blank');
                        // this.$router.push({
                        //     name: "warehouseDeliverUpdate",
                        //     params: {
                        //         type: "add",
                        //         level: this.nowData.type,
                        //     },
                        // });
                    }
                    break;
                case "query":
                    {
                        this.operate = {
                            show: true,
                            width: 1200,
                            title: this.$t('global.common.operation_see',{defaultValue:'查看'}),
                            props: {
                                id: param,
                                type: type,
                                level: this.nowData.type,
                            },
                            component: "compUpdate",
                            showFooter: false,
                        };
                    }
                    break;
                case "edit":
                    {
                        const url = this.$router.resolve({
                            name: "warehouseDeliverUpdate",
                            params: {
                                type: "edit",
                                level: this.nowData.type,
                            },
                            query: { id: param },
                        });
                        window.open(url.href, "_blank");
                    }
                    break;
                case "disable":
                    {
                        this.loading = true;
                        HttpDisableRule({
                            ruleId: param,
                        })
                            .then(
                                (res) => {
                                    this.$VMessage.success(res.message);
                                    this.update();
                                },
                                (err) => {
                                    this.$VMessage.error({
                                        content: err.message,
                                        duration: 30,
                                        closable: true
                                    });
                                }
                            )
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                    break;
                case "active":
                    {
                        this.loading = true;
                        HttpActiveRule({
                            ruleId: param,
                        })
                            .then(
                                (res) => {
                                    this.$VMessage.success(res.message);
                                    this.update();
                                },
                                (err) => {
                                    this.$VMessage.error({
                                        content: err.message,
                                        duration: 30,
                                        closable: true
                                    });
                                }
                            )
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                    break;
            }
        },
    },
    computed: {
        columns() {
            let that = this;
            return [
                {
                    title: this.$t('global.common.operation',{defaultValue:'操作'}),
                    width: 100,
                    render(h, { row }) {
                        let dropDown = {};
                        // 启用
                        if (row.ruleStatus == 1) {
                            dropDown.label = that.$t('fbb.accountmanage.disable',{defaultValue:'禁用'});
                            dropDown.value = "disable";
                        } else {
                            dropDown.label = that.$t('fbb.accountmanage.active',{defaultValue:'启用'});
                            dropDown.value = "active";
                        }

                        return (
                            <div>
                                <vDropdown trigger="click">
                                    <vButton size="small" theme="info">
                                        {that.$t('global.common.operation',{defaultValue:'操作'})}
                                        <vIcon type="arrow-dropdown" />
                                    </vButton>
                                    <vDropdownMenu
                                        style="font-size: 12px;"
                                        slot="list"
                                    >
                                        <vDropdownItem
                                            nativeOnClick={that.handleOperate.bind(
                                                this,
                                                "query",
                                                row.id
                                            )}
                                        >
                                            {that.$t('global.common.operation_see',{defaultValue:'查看'})}
                                        </vDropdownItem>
                                        <vDropdownItem
                                            nativeOnClick={that.handleOperate.bind(
                                                this,
                                                "edit",
                                                row.id
                                            )}
                                        >
                                            {that.$t('global.common.operation_edit',{defaultValue:'编辑'})}
                                        </vDropdownItem>
                                        <vDropdownItem
                                            nativeOnClick={that.handleOperate.bind(
                                                this,
                                                dropDown.value,
                                                row.id
                                            )}
                                        >
                                            {dropDown.label}
                                        </vDropdownItem>
                                    </vDropdownMenu>
                                </vDropdown>
                            </div>
                        );
                    },
                },
                {
                    title: this.$t('erp.rules.rulename',{defaultValue:'规则名称'}),
                    key: "ruleName",
                    render(h, { row }) {
                        return (
                            <a
                                onClick={that.handleOperate.bind(
                                    this,
                                    "query",
                                    row.id,
                                    "query"
                                )}
                            >
                                {row.ruleName}
                            </a>
                        )
                    }
                },
                {
                    title: this.$t('erp.b2c.search_outwarehouse',{defaultValue:'发货仓库'}),
                    key: "warehouseName",
                },
                {
                    title: this.$t('global.common.status',{defaultValue:'状态'}),
                    key: "ruleStatus",
                    width: 100,
                    render(h, { row }) {
                        let obj = that.statusList.filter((item) => {
                            return item.value === row.ruleStatus;
                        })[0] || {};
                        return <div>
                        <div class={obj.color}>{obj.label}</div></div>;
                    },
                },
                {
                    title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    key: 'createdAt',
                    width: 160,
                },
                {
                    title: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                    key: "updatedAt",
                    width: 160,
                },
            ];
        },
    },
};
</script>

<style>
</style>